import { datadogLogs } from '@datadog/browser-logs';

type Primitive = number | string | boolean | bigint | symbol | null | undefined;

export function reportMessage({
    message,
    tags = {},
    error,
}: {
    message: string;
    tags?: { [key: string]: Primitive };
    error?: Error;
    level?: number;
}): void {
    datadogLogs.logger.error(
        message,
        {
            tags,
        },
        error
    );
}
